export const StoreType = Object.freeze({
  /**
   * 网络店铺
   */
  shop: 'shop',
  /**
   * 实体店
   */
  store: 'store',
  /**
   * 维修站
   */
  station: 'station',

  options() {
    return [
      { label: '网络店铺', value: this.shop },
      { label: '实体店', value: this.store },
      { label: '维修站', value: this.station }
    ]
  },
  filter(value) {
    return this.options().find(item => item.value === value) || {}
  }
})
